import { Component, input, viewChild, type InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { UIconModule } from '../u-icon/u-icon.module';

@Component({
  selector: 'u-expansion-panel',
  templateUrl: './u-expansion-panel.component.html',
  styleUrls: ['./u-expansion-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, MatExpansionModule, UIconModule],
})
export class UExpansionPanelComponent {
  panel = viewChild(MatExpansionPanel);
  expanded: InputSignal<boolean> = input<boolean>();

  closePanel() {
    const panelInstance = this.panel();
    if (panelInstance) {
      panelInstance.close();
    }
  }
}
